import React, { useState } from "react";
import { IAccount } from "../../../../lib/features/accounts/account.constant";
import { Button } from "antd";
import ModalUpdateAccount from "../modal/ModalUpdateAccount";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonUpdateAccountProps {
  account: IAccount;
}

const ButtonUpdateAccount: React.FC<ButtonUpdateAccountProps> = (
  props: ButtonUpdateAccountProps
) => {
  const { account } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
    useModalLockScroll(isModalOpen);
  return (
    <div>
      <Button

        onClick={showModal}
        className="font-medium w-full"
        type="primary"
      >
        Cập nhật
      </Button>
      <ModalUpdateAccount
        accountId={account?._id}
        onClose={handleCancel}
        visible={isModalOpen}
      />
    </div>
  );
};

export default ButtonUpdateAccount;
